import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
    type IsoAndUnixTimestamp,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import {
    providerIdZodSchema,
    type ProviderId,
} from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { ticketIdZodSchema, type TicketId } from "../ticket-id";

type RevertRedeemedVoucherTicketCommand = {
    readonly _id: string;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _type: "REVERT_REDEEMED_VOUCHER_TICKET_COMMAND";
    readonly ticketId: TicketId;
    readonly providerId: ProviderId;
};

type FactoryParams = Except<
    RevertRedeemedVoucherTicketCommand,
    "_id" | "_type" | "_createdAt"
>;
const revertRedeemedVoucherTicketCommandFactory = (
    params: FactoryParams,
): RevertRedeemedVoucherTicketCommand => {
    return {
        ...params,
        _id: generateId("REDEEM_VOUCHER_TICKET_COMMAND_"),
        _type: "REVERT_REDEEMED_VOUCHER_TICKET_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
};

const revertRedeemedVoucherTicketCommandZodSchema: z.ZodSchema<RevertRedeemedVoucherTicketCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("REVERT_REDEEMED_VOUCHER_TICKET_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        ticketId: ticketIdZodSchema,
    });

export {
    revertRedeemedVoucherTicketCommandFactory,
    revertRedeemedVoucherTicketCommandZodSchema,
};
export type {
    RevertRedeemedVoucherTicketCommand,
    FactoryParams as RevertRedeemedVoucherTicketCommandProps,
};
